import { useState } from 'react';

export interface SignUpFormData {
  email: string;
  password: string;
  passwordConfirmation: string;
  fullName: string;
}

export interface SignUpValidationErrors {
  email?: string;
  password?: string;
  passwordConfirmation?: string;
  fullName?: string;
  general?: string;
}

export function useSignUpValidation() {
  const [errors, setErrors] = useState<SignUpValidationErrors>({});

  const validate = (formData: SignUpFormData): boolean => {
    const newErrors: SignUpValidationErrors = {};

    // Email validation
    if (!formData.email.trim()) {
      newErrors.email = 'E-mail é obrigatório';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'E-mail inválido';
    }

    // Full name validation
    if (!formData.fullName.trim()) {
      newErrors.fullName = 'Nome completo é obrigatório';
    } else if (formData.fullName.trim().length < 2) {
      newErrors.fullName = 'Nome deve ter pelo menos 2 caracteres';
    }

    // Password validation
    if (!formData.password.trim()) {
      newErrors.password = 'Senha é obrigatória';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Senha deve ter pelo menos 6 caracteres';
    }

    // Password confirmation validation
    if (!formData.passwordConfirmation.trim()) {
      newErrors.passwordConfirmation = 'Confirmação de senha é obrigatória';
    } else if (formData.password !== formData.passwordConfirmation) {
      newErrors.passwordConfirmation = 'As senhas não coincidem';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const clearErrors = () => {
    setErrors({});
  };

  const setError = (field: keyof SignUpValidationErrors, message: string) => {
    setErrors(prev => ({ ...prev, [field]: message }));
  };

  return {
    errors,
    validate,
    clearErrors,
    setError,
  };
}